import { render, staticRenderFns } from "./ChatAssistant.vue?vue&type=template&id=583d043a"
import script from "./ChatAssistant.vue?vue&type=script&lang=js"
export * from "./ChatAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports